export const LOGIN_PATH = "/api/miner/login";

// 每次登录读取当前的小程序启动信息，保留原有邀请及来源参数。
export function getTelegramLoginParams(webApp, projectId) {
  const parts = String(webApp?.initDataUnsafe?.start_param || "").split("_");
  return {
    initdata: webApp?.initData || "",
    project_id: projectId,
    pid: parts[1] || "",
    utm_source: parts[0] === "detail" ? "" : parts[0],
    utm_medium: parts[2] || "",
    subid: parts[3] || "",
  };
}

export function installSessionRecovery(service, { getToken, saveToken, getLoginParams }) {
  let loginPromise = null;
  const apiOrigin = new URL(service.defaults.baseURL).origin;

  function requestType(config) {
    const url = new URL(config.url, config.baseURL || service.defaults.baseURL);
    if (url.origin !== apiOrigin) return "external";
    if (url.pathname === LOGIN_PATH) return "login";
    return url.pathname.startsWith("/api/") ? "authenticated" : "public";
  }

  async function ensureToken() {
    // 多个请求同时发现前端缓存到期或缺失时，共用一次登录获取新凭证。
    if (loginPromise) return loginPromise;
    const currentToken = getToken();
    if (currentToken) return currentToken;

    loginPromise = Promise.resolve().then(async () => {
      const params = getLoginParams();
      if (!params.initdata) throw new Error("Telegram login data is unavailable");
      const response = await service.post(LOGIN_PATH, params);
      const result = response.data;
      if (Number(result?.code) !== 200 || typeof result?.data?.token !== "string" || !result.data.token.trim()) {
        throw new Error(result?.message || result?.msg || "Unable to restore login session");
      }
      saveToken(result.data.token);
      return result.data.token;
    }).finally(() => {
      // 登录失败也释放等待状态，下一次操作仍然能够重新尝试。
      loginPromise = null;
    });
    return loginPromise;
  }

  service.interceptors.request.use(async (config) => {
    config.headers = config.headers || {};
    const type = requestType(config);
    if (type === "login") {
      // 登录接口直接发送，避免为了获取凭证而再次调用自身。
      delete config.headers.Authorization;
      return config;
    }
    const token = type === "authenticated" ? await ensureToken() : getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    else delete config.headers.Authorization;
    return config;
  });

}
